import React from 'react';
import { MapPin, Mail, Phone, Clock } from 'lucide-react';
export function Footer() {
  return <footer id="footer" className="bg-white pt-20 pb-10 border-t border-slate-100" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4" data-id="element-46">
        <div className="grid md:grid-cols-2 gap-16 mb-16" data-id="element-47">
          {/* Left: Hours */}
          <div data-id="element-48">
            <div className="flex items-center gap-2 mb-6" data-id="element-49">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-50" />
              <span className="text-green-600 font-bold text-sm uppercase tracking-wider" data-id="element-51">
                We Are Open Now
              </span>
            </div>
            <h3 className="text-xl font-bold text-[#0F2C59] mb-6 flex items-center gap-2" data-id="element-52">
              <Clock size={20} data-id="element-53" />
              Operational Schedule
            </h3>
            <div className="space-y-3" data-id="element-54">
              {[{
              day: 'Monday - Thursday',
              hours: '8:00 AM - 6:00 PM'
            }, {
              day: 'Friday',
              hours: '8:00 AM - 4:00 PM'
            }, {
              day: 'Saturday',
              hours: '9:00 AM - 2:00 PM'
            }, {
              day: 'Sunday',
              hours: 'Closed'
            }].map(item => <div key={item.day} className="flex justify-between border-b border-slate-50 pb-2" data-id="element-55">
                  <span className="text-slate-600" data-id="element-56">{item.day}</span>
                  <span className="font-bold text-[#0F2C59]" data-id="element-57">{item.hours}</span>
                </div>)}
            </div>
          </div>

          {/* Right: Contact & Map */}
          <div data-id="element-58">
            <h3 className="text-xl font-bold text-[#0F2C59] mb-6" data-id="element-59">
              Contact & Location
            </h3>
            <div className="space-y-6" data-id="element-60">
              <div className="flex gap-4" data-id="element-61">
                <div className="w-10 h-10 bg-slate-50 rounded-lg flex items-center justify-center text-[#4F709C]" data-id="element-62">
                  <MapPin size={20} data-id="element-63" />
                </div>
                <div data-id="element-64">
                  <p className="font-bold text-[#0F2C59]" data-id="element-65">
                    Silver Spring Office
                  </p>
                  <p className="text-slate-500 text-sm" data-id="element-66">
                    1234 Colesville Rd, Silver Spring, MD 20904
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-67">
                <div className="w-10 h-10 bg-slate-50 rounded-lg flex items-center justify-center text-[#4F709C]" data-id="element-68">
                  <Mail size={20} data-id="element-69" />
                </div>
                <div data-id="element-70">
                  <p className="font-bold text-[#0F2C59]" data-id="element-71">
                    Secure Medical Email
                  </p>
                  <p className="text-slate-500 text-sm" data-id="element-72">
                    care@colesvilledental.com
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-73">
                <div className="w-10 h-10 bg-slate-50 rounded-lg flex items-center justify-center text-[#4F709C]" data-id="element-74">
                  <Phone size={20} data-id="element-75" />
                </div>
                <div data-id="element-76">
                  <p className="font-bold text-[#0F2C59]" data-id="element-77">Direct Line</p>
                  <p className="text-slate-500 text-sm" data-id="element-78">(301) 555-0123</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-slate-100 text-center text-slate-400 text-xs" data-id="element-79">
          <p data-id="element-80">
            © 2026 Colesville Dental Center. All Rights Reserved. Professional
            Dentistry & Orthodontics.
          </p>
        </div>
      </div>
    </footer>;
}